export default "__VITE_ASSET__BY8iT1uk__"